// import { Typography } from '@mui/material';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import paths from '../../lib/consts/paths';
import { FormField } from '../../lib/interfaces/Form';
import { IProduct } from '../../lib/interfaces/Product';
import Form from '../Form/Form';
import Loader from '../Simple/Loader/Loader';
import { getFieldsByFormType } from './productOrderFormFieds';
import './ProductOrderForm.scss';

type ProductOrderFormType = {
	saveFormValues: (values: any, formFields: FormField[]) => void;
	product: IProduct;
};

const ProductOrderForm: FC<ProductOrderFormType> = ({
	saveFormValues,
	product,
}) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const formFields = product ? getFieldsByFormType[product.detailsFormId]() : [];
	if (formFields?.length) {
		formFields.forEach((field) => {
			field.label = t(field.label);
		});
	}

	useEffect(() => {
		if (!formFields.length) {
			navigate(paths.products);
		}
	}, [formFields]);

	const handleSubmit = (values: any) => {
		saveFormValues(values, formFields);
	};

	return formFields.length ? (
		<div className="ProductOrderForm">
			{/* <Typography
				variant="body1"
				component="div"
				style={{ paddingBottom: '10px' }}
			>
				{t('fillOrderDetails')}
			</Typography> */}
			<Form
				fields={formFields}
				onSubmit={handleSubmit}
				saveButtonName={t('next')}
				isLoading={false}
			/>
		</div>
	) : (
		<div>
			<Loader />
		</div>
	);
};

export default ProductOrderForm;
